import React from "react";
import { Star, ExternalLink, AlertTriangle, Award } from "lucide-react";

const usd = (v) => `$${Number(v).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const ShopOffers = ({ d }) => {
  const offers = d.offers || [];
  if (!offers.length) return null;
  const bv = d.best_value;
  return (
    <div className="space-y-1.5" data-testid="shop-offers">
      {d.identified_from_photo && <p className="text-[11px] text-cyan-300/60" data-testid="shop-identified">From your photo: <b className="text-cyan-100">{d.identified_from_photo}</b></p>}
      {offers.map((o, i) => (
        <a key={i} href={o.url || "#"} target="_blank" rel="noreferrer" data-testid={`shop-offer-${i}`}
          className={`block px-3 py-2 rounded-lg border transition-colors ${bv && bv.retailer === o.retailer && bv.price === o.price ? "border-emerald-500/50 bg-emerald-500/10" : "border-[#00F0FF1a] bg-[#0a1020] hover:bg-[#00F0FF0a]"}`}>
          <div className="flex items-center gap-2">
            <span className="text-cyan-50 text-sm font-medium flex-1 truncate">{i + 1}. {o.retailer}</span>
            {o.rating != null && <span className="inline-flex items-center gap-1 text-amber-300 text-xs"><Star className="w-3.5 h-3.5 fill-amber-300" />{o.rating}{o.rating_count ? <span className="text-cyan-300/50">({Number(String(o.rating_count).replace(/,/g, "")).toLocaleString()})</span> : null}</span>}
            {o.low_rating && <span className="text-[10px] font-bold text-rose-300 border border-rose-500/40 rounded px-1 flex items-center gap-0.5" data-testid="shop-offer-low-rating"><AlertTriangle className="w-3 h-3" />under 4.0</span>}
            <span className="text-sm font-bold tabular-nums text-cyan-100">{usd(o.price)}</span>
            <ExternalLink className="w-3.5 h-3.5 text-cyan-300/40 shrink-0" />
          </div>
          {o.review_line && <p className="text-[11px] text-cyan-200/60 mt-0.5 line-clamp-1">{o.review_line}</p>}
        </a>
      ))}
      {bv && (
        <p className="text-xs text-emerald-200 flex items-center gap-1.5 pt-1" data-testid="shop-best-value"><Award className="w-4 h-4 text-emerald-300" />Best value: <b>{bv.retailer}</b> — {bv.why}</p>
      )}
    </div>
  );
};
